// Print-safe Stone palette used by DebtStudio and FundPlanner PDF reports.
export const PDF_STONE = {
  primary: [79, 91, 102], // Graphite #4F5B66
  secondary: [112, 102, 92], // Taupe #70665C
  accent: [130, 95, 67], // Walnut #825F43
  primaryLight: [126, 139, 150],
  secondaryLight: [169, 159, 149],
  accentLight: [184, 145, 113],
  primaryDark: [57, 68, 78],
  secondaryDark: [86, 75, 66],
  accentDark: [101, 70, 47],
  white: [255, 255, 255],
  surface: [248, 248, 247],
  alternateRow: [252, 251, 250],
  border: [218, 216, 213],
  grid: [224, 222, 219],
  axis: [125, 122, 118],
};

export const PDF_STONE_SERIES = [
  PDF_STONE.primary,
  PDF_STONE.secondary,
  PDF_STONE.accent,
  PDF_STONE.primaryLight,
  PDF_STONE.secondaryLight,
  PDF_STONE.accentLight,
  PDF_STONE.primaryDark,
  PDF_STONE.secondaryDark,
  PDF_STONE.accentDark,
];

// High-contrast categorical colors for charts. Keep structural report colors
// (headings, tables, borders, and axes) on the Stone palette above.
export const PDF_CHART_SERIES = [
  [42, 83, 138], // Deep blue #2A538A
  [205, 112, 32], // Orange #CD7020
  [54, 126, 83], // Green #367E53
  [151, 65, 71], // Red #974147
  [104, 76, 145], // Purple #684C91
  [65, 132, 143], // Teal #41848F
];
